import React, { FC, useEffect, useState } from "react";
import { Button, InputField } from "../../forms";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { addressRegex, emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { toast } from "react-toastify";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { onAddContact, onUpdateContact } from "../../../services/crm/contacts";
import Spinner from "../../generic/Spinner";

export default ({
  show,
  isedit,
  item,
}: {
  show: (stat: boolean) => void;
  isedit: boolean;
  item?: any;
}) => {
  var { control, handleSubmit, watch, setValue } = useForm();
  const contactypehook = usePickerhook();
  const watchedFields = watch(["email", "phone"]);
  const { config } = useStateGetter();

  const queryClient = useQueryClient();
  const { SelectedOrg } = useStateGetter();
  const { mutateAsync: addContactMutate, isPending } = useMutation({
    mutationFn: (postdata: any) => onAddContact(postdata, config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts_list"] });
      show(false);
    },
    onError: (e: any) => {
      toast.error(e);
    },
  });
  const { mutateAsync: updateContactMutate, isPending: updatePending } =
    useMutation({
      mutationFn: (postdata: any) => onUpdateContact(item.id,postdata, config),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["contacts_list"] });
        toast.success("Updated")
        show(false);
      },
      onError: (e: any) => {
        toast.error(e);
      },
    });
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined && contactypehook.pickedRole
  );

  const onSubmit = async (data: any) => {
    var postdata = {
      name: data.contact,
      type: contactypehook.pickedRole.code,
      position: data.position,
      email: data.email,
      phone_number: data.phone,
      organization_id: SelectedOrg.id,
    };
    if (isedit) {
      await updateContactMutate({
        name: data.contact,
        type: contactypehook.pickedRole.code,
        position: data.position,
        phone_number: data.phone,
        
      });
    } else {
      await addContactMutate(postdata);
    }
  };

  useEffect(() => {
    if (isedit) {
      setValue("email", item.email);
      setValue("phone", item.phone_number);
      setValue("position", item.position);
      setValue("contact", item.name);
      contactypehook.setPickedRole({ name: item.type, code: item.type });
    }
  }, []);
  return (
    <>
      <div className="ModalContainer shadow ">
        <Spinner loading={isPending} />

        <div className=" flex flex-col  max-h-[80vh] overflow-y-scroll  rounded-[8px] bg-white w-[40vw] px-4 py-6">
          <p className="font-semibold self-start text-sm ">
            {isedit ? "Edit Contact" : "Add Contact"}
          </p>
          <InputField
            name="contact"
            title="Contact"
            placeholder={"Contact"}
            control={control}
            rules={{
              required: "is required",
              pattern: {
                value: textReg,
                message: "Invalid",
              },
            }}
          />
          <ListPicker
            fullwidth
            hook={contactypehook}
            title="Contact Type"
            list={[
              { name: "Individual", code: "individual" },
              { name: "Organization", code: "organization" },
            ]}
          />

          <InputField
            name="position"
            title="Job Position"
            placeholder={"Job Position"}
            control={control}
            rules={{
              required: "is required",
              pattern: {
                value: textReg,
                message: "Invalid",
              },
            }}
          />

          <div className=" grid grid-cols-2   gap-x-4 ">
            <InputField
              name="email"
              title="Email address"
              placeholder={"Email address"}
              control={control}
              isDisabled={isedit}
              rules={{
                required: "is required",
                pattern: {
                  value: emailReg,
                  message: "Invalid",
                },
              }}
            />
            <InputField
              name="phone"
              title="Phone number"
              placeholder={"Phone number"}
              control={control}
              rules={{
                required: "is required",
                pattern: {
                  value: numReg,
                  message: "Invalid",
                },
              }}
            />
          </div>
          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text={isedit ? "Update Contact" : "Add Contact"}
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
